module.exports = __webpack_public_path__ + "static/media/fourWarriors-2.a1aea533.png";